module.exports = __webpack_public_path__ + "media/images/maserati-fbc9b36703c3ec9943aa095a6cefda14.svg";